import { scope } from '../../hoc/withPermissions'
import { usePermission } from '../usePermission/usePermission'
import { usePostHogFeatureFlag } from '../usePostHogFeatureFlag/usePostHogFeatureFlag'
import { POSTHOG_FEATURE_FLAGS } from '../usePostHogFeatureFlag/posthogFeatureFlags'
import { useQuery } from '../useQuery/useQuery'

import { getRewardRulesConfiguration } from '@percent/workplace-giving/api/gamification/getRewardRulesConfiguration/getRewardRulesConfiguration'

export function useRewardRulesConfiguration() {
  const has = usePermission()
  const rewardsVisible = usePostHogFeatureFlag(POSTHOG_FEATURE_FLAGS.WPG_VOLUNTEERING_REWARDS_VISIBILITY)

  return useQuery(['getRewardRulesConfiguration'], getRewardRulesConfiguration, {
    staleTime: 1000 * 60,
    enabled: rewardsVisible && has(scope('gamification'))
  })
}
